
























import Vue from 'vue'
//@ts-ignore
import LZString from 'lz-string'

declare const Diagram: any

export default Vue.extend({
    data() {
        return {
            tab: 0,
            code: '',
        }
    },
    computed: {
        codeOptions() {
            return {
                lineNumbers: true,
                tabSize: 4,
            }
        },
    },
    mounted() {
        const qs = {} as any
        if (location.hash) {
            location.hash.substr(1).split('&')
                .forEach(item => {
                    const [key, val] = item.split('=', 2)
                    if (val) {
                        qs[key] = decodeURIComponent(val)
                    }
                })
        }
        if (qs.code) {
            this.code = LZString.decompressFromBase64(qs.code)
        }
        if (qs.tab) {
            this.tab = parseInt(qs.tab)
        }
    },
    methods: {
        makeShareUrl() {
            location.hash = 'code=' + encodeURIComponent(LZString.compressToBase64(this.code)) + '&tab=1'
        },
    },
    watch: {
        tab(val) {
            if (val != 1) {
                const g = document.getElementById('graph')
                if (g) {
                    g.innerHTML = ''
                }
            } else {
                this.$nextTick(() => {
                    try {
                        Diagram.parse(this.code).drawSVG('graph', {theme: 'simple'})
                    } catch(e) {
                        console.error(e)
                    }
                })
            }
        },
    },
})
